"use strict";
exports.__esModule = true;
exports.MONEY_SYMBOLS = {
    EUR: '€',
    CZK: 'Kč',
    TRY: '₺',
    GBP: '£',
    CHF: 'CHF',
    CNY: '¥',
    RUB: '₽',
    INR: '₹',
    AED: 'د.إ',
    KWD: 'دينار',
    SAR: '﷼',
    BHD: 'دينار',
    QAR: '﷼',
    HKD: 'HK$',
    KRW: '₩',
    MOP: 'MOP$',
    TWD: 'NT$',
    THB: '฿',
    AUD: '$',
    MYR: 'RM',
    SGD: '$',
    JPY: '¥',
    USD: '$',
    CAD: '$',
    MXN: '$',
    BRL: 'R$',
    DKK: 'DKK'
};
//# sourceMappingURL=money.symbols.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@qwentes/models/lib/packages/money/money.symbols.js
// module id = 161
// module chunks = 0